import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function useLedgerReload(slug: string, reload: () => void) {
  const { ledger } = useAuth();
  const reloadRef = useRef(reload);
  reloadRef.current = reload;
  useEffect(() => {
    if (!ledger) return;
    if (ledger.resources.some((resource) => slug.includes(resource))) reloadRef.current();
  }, [ledger, slug]);
}
